"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverrideUtils = void 0;
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
var OverrideUtils = /** @class */ (function () {
    // @ts-ignore
    // @ts-ignore
    function OverrideUtils($filter, $injector) {
        this.translate = $filter('translate');
        this.compatibleWidgets = $injector.get('pr.widgetConstants').getCompatibleWidgets();
    }
    /**
     * Remove disabled fields (fields that only work with disabled widgets)
     */
    // @ts-ignore
    // @ts-ignore
    OverrideUtils.prototype.removeDisabledFields = function (menu, disabledWidgets) {
        var _this = this;
        // @ts-ignore
        var shouldRemove = function (item) {
            var fieldType = lodash_1.default.get(item, 'value.type');
            var compatibleWidgetsForType = _this.compatibleWidgets[fieldType];
            return lodash_1.default.every(compatibleWidgetsForType, function (widget) {
                return lodash_1.default.includes(disabledWidgets, widget);
            });
        };
        var FIELD_SUBMENU_FIELDS = [
            'QUESTIONS',
            'FIELDS_MENU_CONFIG.SURVEY_EMBEDDEDDATA',
            'FIELDS_MENU_CONFIG.SURVEY_METADATA'
        ].map(this.translate);
        lodash_1.default.forEach(menu, function (submenu) {
            if (!lodash_1.default.includes(FIELD_SUBMENU_FIELDS, submenu.label)) {
                return;
            }
            _this.removeItems(submenu.submenu.items, shouldRemove, 'submenu.items');
        });
    };
    // @ts-ignore
    // @ts-ignore
    OverrideUtils.prototype.removeDisabledWidgets = function (menu, disabledWidgets) {
        var widgetsSubmenu = lodash_1.default.find(menu, {
            label: this.translate('VISUALIZATION')
        });
        // @ts-ignore
        this.removeItems(widgetsSubmenu.submenu.items, function (item) {
            return lodash_1.default.includes(disabledWidgets, item.value);
        }, 'submenu.items');
    };
    // @ts-ignore
    // @ts-ignore
    // @ts-ignore
    OverrideUtils.prototype.removeItems = function (array, shouldRemove, nestedArrayPath) {
        for (var i = array.length - 1; i >= 0; i--) {
            var item = array[i] || {};
            var nestedArray = lodash_1.default.get(item, nestedArrayPath);
            if (lodash_1.default.isArray(nestedArray) && nestedArray.length) {
                this.removeItems(nestedArray, shouldRemove, nestedArrayPath);
                if (!nestedArray.length) {
                    array.splice(i, 1);
                }
            }
            else if (shouldRemove(item)) {
                array.splice(i, 1);
            }
        }
    };
    /**
     * Override the init widget config if it is for a disabled widget
     */
    // @ts-ignore
    // @ts-ignore
    OverrideUtils.prototype.updateInitWidgetConfig = function (data, disabledWidgets) {
        var config = data.config;
        var field = data.field;
        if (lodash_1.default.includes(disabledWidgets, config.type)) {
            var compatibleWidgetsForType = this.compatibleWidgets[field.type];
            var widgetType = lodash_1.default.find(compatibleWidgetsForType, function (widget) {
                return !lodash_1.default.includes(disabledWidgets, widget);
            });
            if (widgetType) {
                config.type = widgetType;
            }
            else {
                console.error('Could not find compatible widget for field', field.type);
            }
        }
    };
    return OverrideUtils;
}());
exports.OverrideUtils = OverrideUtils;
(function (module) {
    module.factory('pr.overrideUtils', [
        '$filter',
        '$injector',
        // @ts-ignore
        // @ts-ignore
        function ($filter, $injector) { return new OverrideUtils($filter, $injector); }
    ]);
})(angular_1.module('qualtrics.pr'));
